import { Plugin } from 'vue';
// SSR related
import cFooter from '@/components/c-footer.vue';
import cHeader from '@/components/c-header.vue';
import lArticleDetail from '@/layouts/l-article-detail.vue';
import lArticlesList from '@/layouts/l-articles-list.vue';
import lBundleDetail from '@/layouts/l-bundle-detail.vue';
import lCategoriesOverview from '@/layouts/l-categories-overview.vue';
import lDefault from '@/layouts/l-default.vue';
import lDownloadCenter from '@/layouts/l-download-center.vue';
import lFavoritesOverview from '@/layouts/l-favorites-overview.vue';

const plugin: Plugin = {
  install(app) {
    const components = [
      // SSR related
      cHeader,
      cFooter,
      lDefault,
      lArticleDetail,
      lArticlesList,
      lBundleDetail,
      lCategoriesOverview,
      lDownloadCenter,
      lFavoritesOverview,
    ];

    components.forEach((component) => {
      app.component(component.name || '', component);
    });
  },
};

export default plugin;
